import { render } from "./packaging.vue?vue&type=template&id=6c794406&scoped=true&ts=true"
import script from "./packaging.vue?vue&type=script&lang=ts"
export * from "./packaging.vue?vue&type=script&lang=ts"

import "./packaging.vue?vue&type=style&index=0&id=6c794406&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c794406"]])

export default __exports__